export const locales = {
    ru: {
        title: 'Может,',
        subtitle: 'что-нибудь ещё?',
        submitText: 'Нет, спасибо',
        fullButtonText: 'Оформить заказ',
    },
    en: {
        title: 'Anything else?',
        submitText: 'No, thank you',
        fullButtonText: 'Checkout',
    },
};
